export const unitType = ["Single", "Multiple"];
export default unitType;
